<template>
  <section class="document-cta">
    <div class="document-cta__text">
      <h2 class="document-cta__title" v-html="getTitleBlock(page, 'cta', 'title')"></h2>
      <p v-if="relatedLinks.length" class="document-cta__related">
        <span v-html="getTitleBlock(page, 'cta', 'description')"></span>
        <router-link
          v-for="item in relatedLinks"
          :key="item.key"
          class="document-cta__link"
          :to="{ name: 'resource-document', params: { slug: item.key } }"
        >
          {{ item.value }}
        </router-link>
      </p>
    </div>
    <OrangeFancyButtonWithArrowAnimation hash="#resources-form" class="document-cta__button">Отримати PDF</OrangeFancyButtonWithArrowAnimation>
  </section>
</template>

<script>
import { textBlock } from '@/entities/text-block';
import { findPublishedResourceDocument } from '@/features/agent-resources/lib';
import { OrangeFancyButtonWithArrowAnimation } from '@/shared/ui/form';

export default {
  props: {
    page: {
      type: String,
      required: true,
    },
    slug: {
      type: String,
      required: true,
    },
  },
  mixins: [ textBlock ],
  components: { OrangeFancyButtonWithArrowAnimation },
  computed: {
    relatedLinks() {
      return this.getListBlock(this.page, 'related-list')
        .filter((item) => item.key !== this.slug && findPublishedResourceDocument(item.key));
    },
  },
};
</script>

<style lang="scss" scoped>
.document-cta {
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 40px;
  border-radius: 28px;
  background: #CBDDFA;

  @media (max-width: 800px) {
    padding: 24px 16px;
  }

  &__title {
    margin: 0 0 12px;
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 500;
    font-size: clamp(30px, 3.4vw, 44px);
    line-height: 1.15;
  }

  &__related {
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    gap: 8px 20px;
    font-size: 16px;
    color: #494E53;
  }

  &__link {
    color: #4555CC;
    text-decoration: underline;

    &:hover {
      color: #373A3D;
    }
  }

  &__button {
    width: auto;
    border-radius: 16px;
    box-shadow: 0 16px 48px rgba(235, 140, 66, 0.25);
  }
}
</style>
